// extracted by mini-css-extract-plugin
var _1 = "DocumentsStyles-module__buttons___sW_NB";
var _2 = "DocumentsStyles-module__documents___PSDgM";
var _3 = "DocumentsStyles-module__documents-edit___Ri3Gr";
var _4 = "DocumentsStyles-module__documents-section___FCXgw";
var _5 = "DocumentsStyles-module__documents-year___PSeoJ";
var _6 = "DocumentsStyles-module__documents_doc___JnUUE";
var _7 = "DocumentsStyles-module__documents-edit___Ri3Gr";
var _8 = "DocumentsStyles-module__documents-section___FCXgw";
var _9 = "DocumentsStyles-module__documents_showAll___kOMsi";
var _a = "DocumentsStyles-module__documents-year___PSeoJ";
var _b = "DocumentsStyles-module__documents_doc___JnUUE";
var _c = "DocumentsStyles-module__documents_showAll___kOMsi";
var _d = "DocumentsStyles-module__empty___yvUPQ";
var _e = "DocumentsStyles-module__value-holder___cvqFL";
var _f = "DocumentsStyles-module__value-holder___cvqFL";
export { _1 as "buttons", _2 as "documents", _3 as "documents-edit", _4 as "documents-section", _5 as "documents-year", _6 as "documentsDoc", _7 as "documentsEdit", _8 as "documentsSection", _9 as "documentsShowAll", _a as "documentsYear", _b as "documents_doc", _c as "documents_showAll", _d as "empty", _e as "value-holder", _f as "valueHolder" }
